import { getProjectInvoiceTypeColor, getProjectInvoiceTypeString } from "@msuite/utils/projects";
import type { Enums } from "@msuite/utils/types";
import { useTranslation } from "../localization";
import { Tag, type TagProps } from "./tag";

/** Props Interface */
interface ProjectInvoiceTagProps extends Partial<TagProps> {
	type: Enums<"outgoingInvoiceType">;
}

export function ProjectInvoiceTag({ type, ...props }: ProjectInvoiceTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Tag
			color={getProjectInvoiceTypeColor(type)}
			{...props}
		>
			{t(getProjectInvoiceTypeString(type))}
		</Tag>
	);
}
